function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata2"
});
var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs7"
}, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  id: "rect4",
  height: 63,
  width: 62,
  y: 356,
  x: 533
})));
var SvgProductAssessment = function SvgProductAssessment(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    id: "svg43",
    overflow: "hidden",
    viewBox: "0 0 62 61",
    height: 62,
    width: 61,
    ref: svgRef
  }, props), _ref2, _ref3, React.createElement("path", {
    d: "m 0.5,31 c 0,-16.845 13.432,-30.5 30,-30.5 16.569,0 30,13.655 30,30.5 0,16.845 -13.431,30.5 -30,30.5 -16.568,0 -30,-13.655 -30,-30.5 z",
    fill: "#81842d",
    stroke: "#5f6321",
    strokeMiterlimit: 8,
    id: "path9",
    style: {
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fill: "#ebeef2",
      fillOpacity: 1
    }
  }), React.createElement("g", {
    id: "g948",
    transform: "translate(1.0824568,2.1821383)"
  }, React.createElement("path", {
    d: "m 33.86,13.5 0.09,0.143 c 0.908,0.971 2.163,1.571 3.549,1.571 1.386,0 2.641,-0.6 3.549,-1.571 l 0.09,-0.143 0.737,0.159 c 2.13,0.962 3.624,3.216 3.624,5.842 v 5.315 l -2.594,1.007 c -1.753,0.446 -3.566,0.677 -5.406,0.677 -1.84,0 -3.653,-0.231 -5.406,-0.677 l -2.594,-1.007 v -5.315 c 0,-2.626 1.495,-4.88 3.625,-5.842 z",
    id: "path11",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 32.5,10.5 c 0,-2.761 2.239,-5 5,-5 2.761,0 5,2.239 5,5 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z",
    id: "path13",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 17.86,13.5 0.09,0.143 c 0.908,0.971 2.163,1.571 3.549,1.571 1.386,0 2.641,-0.6 3.549,-1.571 l 0.09,-0.143 0.737,0.159 c 2.13,0.962 3.624,3.216 3.624,5.842 v 5.315 l -2.594,1.007 c -1.753,0.446 -3.566,0.677 -5.406,0.677 -1.84,0 -3.653,-0.231 -5.406,-0.677 l -2.594,-1.007 v -5.315 c 0,-2.626 1.495,-4.88 3.625,-5.842 z",
    id: "path15",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 16.5,10.5 c 0,-2.761 2.239,-5 5,-5 2.761,0 5,2.239 5,5 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z",
    id: "path17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 25.41,10.260076 0.102,0.154 c 1.021,1.045 2.433,1.692 3.992,1.692 1.559,0 2.971,-0.647 3.993,-1.692 l 0.101,-0.154 0.829,0.171 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 l -2.918,-1.084 v -5.724 c 0,-2.829 1.681,-5.255 4.078,-6.292 z",
    id: "path19",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    d: "m 23.5,6.9149552 c 0,-3.037099 2.463,-5.4999998 5.5,-5.4999998 3.038,0 5.5,2.4629008 5.5,5.4999998 0,3.037101 -2.462,5.4999998 -5.5,5.4999998 -3.037,0 -5.5,-2.4628988 -5.5,-5.4999998 z",
    id: "path21",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeOpacity: 1
    }
  })), React.createElement("path", {
    id: "path6",
    d: "m 14.372633,30.681456 c 0,-2.616675 2.12269,-4.738636 4.740264,-4.738636 h 22.753265 c 2.617573,0 4.740263,2.121961 4.740263,4.738636 v 18.954545 c 0,2.616676 -2.12269,4.738636 -4.740263,4.738636 H 19.112897 c -2.617574,0 -4.740264,-2.12196 -4.740264,-4.738636 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 0.999995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path8",
    d: "m 19.198221,25.94282 h 22.582616 c 2.664976,0 4.825588,2.174086 4.825588,4.856155 v 5.568844 H 14.372633 v -5.568845 c 0,-2.682068 2.160612,-4.856154 4.825588,-4.856154 z",
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 0.999995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path10",
    d: "m 9.632367,26.10109 c 0,-2.704813 2.192849,-4.896906 4.898591,-4.896906 h 22.436615 c 2.705743,0 4.898589,2.192093 4.898589,4.896906 v 19.585732 c 0,2.704813 -2.192846,4.896905 -4.898589,4.896905 H 14.530958 c -2.705742,0 -4.898591,-2.192092 -4.898591,-4.896905 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 0.999995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path12",
    d: "m 14.457958,21.204184 h 22.582615 c 2.664977,0 4.825589,2.174086 4.825589,4.856155 v 5.568844 H 9.632367 v -5.568844 c 0,-2.682069 2.160615,-4.856155 4.825591,-4.856155 z",
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 0.999995,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path16",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fill: "#b59da4",
    d: "m 15.320686,25.627227 c 0,-0.348763 0.283468,-0.632134 0.632351,-0.632134 h 19.592457 c 0.349832,0 0.632351,0.283371 0.632351,0.632134 v 2.52664 c 0,0.349713 -0.282519,0.632136 -0.632351,0.632136 H 15.953037 c -0.348883,0 -0.632351,-0.282423 -0.632351,-0.632136 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#002060",
      strokeWidth: 1.15807,
      strokeOpacity: 1
    }
  }), React.createElement("rect", {
    id: "rect18",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#b59da4",
    height: 3.7909091,
    width: 3.7922108,
    y: 35.42009,
    x: 16.268728,
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      stroke: "#002060",
      strokeWidth: 1.15807,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path20",
    strokeMiterlimit: 8,
    fillRule: "evenodd",
    fill: "#d6751e",
    d: "M 24.801213,37.315548 H 36.0053",
    style: {
      stroke: "#002060",
      strokeWidth: 1.15807,
      strokeOpacity: 1
    }
  }), React.createElement("rect", {
    id: "rect22",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#b59da4",
    height: 3.7909091,
    width: 3.7922108,
    y: 43.001907,
    x: 16.268728,
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      stroke: "#002060",
      strokeWidth: 1.15807,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    id: "path26",
    strokeMiterlimit: 8,
    fill: "#d6751e",
    d: "M 24.801213,44.897365 H 36.0053",
    style: {
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1.15807,
      strokeOpacity: 1
    }
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 34.183143,42.797202 -1.168949,0.197127 c -0.831443,0.107093 -1.218248,-0.39615 -0.866521,-1.128743 l 0.474975,-1.087992",
    fill: "#661a39",
    id: "path28"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 39.002095,41.986894 -4.818952,0.810308 -1.560495,-2.019608 1.935923,-4.435363 0.07016,-0.05402",
    fill: "#b59da4",
    id: "path30"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 49.156687,25.145781 0.889274,-0.682362 c 0.894013,-0.640664 2.202326,-0.524095 2.713326,0.07013 0.765079,0.996061 1.530157,1.993071 2.295236,2.99008 0.198143,0.243566 0.267351,0.595172 0.236065,0.968576 -0.05214,0.623606 -0.383961,1.310707 -0.870312,1.669896 l -0.890222,0.682364",
    fill: "#661a39",
    id: "path32"
  }), React.createElement("path", {
    style: {
      fill: "#ecaec6",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 34.628727,36.28821 14.52796,-11.142429 4.373367,5.698684 -14.527959,11.142429 z",
    fill: "#661a39",
    id: "path34"
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductAssessment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-assessment.5a792348.svg";
export { ForwardRef as ReactComponent };